import { setContext } from '@apollo/client/link/context';

const publicLink = setContext((_, prevContext) => {
  const { headers, isPublic } = prevContext;

  if (!isPublic) return {};

  return {
    headers: {
      ...headers,
      'Is-Public': true,
    }
  };
});

export default publicLink;
